<template lang="pug">
.popup(v-if="$parent.subscribePopupOpened")
  .popup-overlay(@click="$parent.subscribePopupOpened = false")
  .popup-body
    .container-fluid
      .row
        .col-md-12
          h1(style="padding: 0" v-if="!subscribed") Subscribe
          h2(style="margin-top: 10px;margin-right: 40px;" v-if="subscribed") Thank you for joining our mailing list
          i.pull-right.fa.fa-times.close-popup(@click="$parent.subscribePopupOpened = false")
      template(v-if="!subscribed")
        form(@submit="submit")
          .row
            .col-md-12
              p(style="margin: 20px 0") Join our list of supporters for our email alerts and the latest campaign opportunities.
          .row
            .col-md-4.subscribe-form-label
              strong First Name
            .col-md-6
              input(type="text" v-model="name" @keydown="delete errors.name" placeholder="John")
              .text-danger.error(v-if="errors.name === 'empty'") Please provide your first name
          .row(style="margin-top: 20px")
            .col-md-4.subscribe-form-label
              strong Email Address
            .col-md-6
              input(type="text" v-model="email" @keydown="delete errors.email" placeholder="email@example.com")
              .text-danger.error(v-if="errors.email === 'empty'") Please provide your email address
              .text-danger.error(v-if="errors.email === 'invalid'") Please provide a valid email address
          .row(style="margin-top: 20px")
            .col-md-4.subscribe-form-label
              strong Privacy
            .col-md-6
              a(href="https://www.electoral-reform.org.uk/privacy-and-cookies/"
                target="_blank") You can read our privacy policy
          .row(style="margin-top: 20px")
            .col-md-4
            .col-md-6
              #consent-radios
                big
                  i.far.fa-circle.clickable(@click="consent = true; delete errors.consent"
                    v-if="consent !== true")
                  i.far.fa-dot-circle(v-if="consent === true")
                span(@click="consent = true; delete errors.consent")  Yes
                big(style="margin-left: 10px")
                  i.far.fa-circle.clickable(@click="consent = false"
                    v-if="consent !== false")
                  i.far.fa-dot-circle(v-if="consent === false")
                span(@click="consent = false")  No
              div(style="margin-top: 5px")  Do you want to be subscribed to our email list to stay up to date with our work?
              .text-danger.error(v-if="errors.consent === 'unchecked'") You need to provide your consent to subscribe
          .row(style="margin-top: 20px")
            .col-md-4
            .col-md-6
              button.btn.btn-primary(type="submit") Subscribe
      template(v-if="subscribed")
        .container-fluid
          .row
            .col-md-12
              .gap-40
              h3.text-center Support our work
              p We are working to create a stronger case for political reform in the UK - but we need your help to take this to the next level.
              p By supporting the
                =" "
                a(href="https://www.electoral-reform.org.uk/join-the-movement/lakeman-fellowship/" target="_blank") Lakeman Fellowship
                |  you will be funding vital investigations which will ensure we can build a stronger-than-ever case for democratic reform across the UK.
          .row
            .col-md-12.text-center
              a(href="https://electoral-reform.netdonor.net/page/22587/donate/1?chain" target="_blank")
                button.btn Donate £5
              a(href="https://electoral-reform.netdonor.net/page/22587/donate/1?chain" target="_blank")
                button.btn Donate £10
              a(href="https://electoral-reform.netdonor.net/page/22587/donate/1?chain" target="_blank")
                button.btn Donate £25
          .row
            .col-md-12
              h3.text-center(style="margin-top: 20px") Follow us
              p Keep up with the latest news from the Society by finding us on social media.
          .row
            .col-md-12.text-center
              a(href="https://www.facebook.com/sharer.php?u=https%3A%2F%2Faction.electoral-reform.org.uk%2Fpage%2F5802%2Fsubscribe%2F1%3Fen_chan%3Dfb%26locale%3Den-GB%26ea.tracking.id%3D"
                target="_blank"
                style="font-size: 60px")
                i.fab.fa-facebook-square(style="color: #4267B2")
              a(href="https://twitter.com/intent/tweet?text=I%27ve%20subscribed%20to%20%40electoralreform%27s%20mailing%20list.%20Sign%20up%20here%3A&url=http://ers.do/subscribe"
                target="_blank"
                style="font-size: 60px;margin-left: 15px")
                i.fab.fa-twitter-square(style="color: #1DA1F2")
</template>

<script>
const axios = require('axios');

const emailRegex = /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/

export default {
  data() {
    return {
      consent: null,
      name: '',
      email: '',
      errors: {},
      subscribed: false,
    }
  },
  methods: {
    submit(e) {
      e.preventDefault()

      const errors = {}

      if (!this.name) {
        errors.name = 'empty'
      }

      if (!this.email) {
        errors.email = 'empty'
      } else if (!this.email.match(emailRegex)) {
        errors.email = 'invalid'
      }

      if (!this.consent) {
        errors.consent = 'unchecked'
      }

      this.errors = errors

      if (Object.keys(errors).length > 0) {
        return
      }

      axios.post(`${this.$parent.backendHost}/subscribe`, {
        name: this.name,
        email: this.email,
      }).then(() => {
        this.subscribed = true
      })
    }
  }
}
</script>

<style lang="scss">
#app {
  overflow: hidden;

  .popup {
    position: fixed;
    width: 100vw;
    height: 100vh;
    z-index: 200000;
    top: 0;
    left: 0;
    overflow: scroll;
    background-color: rgba(255, 255, 255, 0.8);

    .popup-overlay {
      position: fixed;
      z-index: 1;
      top: 0;
      left: 0;
      height: 100%;
      width: 100%;
      cursor: pointer;
    }

    .popup-body {
      position: relative;
      z-index: 2;
      top: 20px;
      max-width: 640px;
      margin: 0 auto;
      padding: 20px 10px;
      background-color: white;
      box-shadow: 2px 2px 20px rgba(0, 0, 0, 0.3);
      border-radius: 4px;
      margin-bottom: 20px;

      @media only screen and (max-width: 640px) {
        box-shadow: none;
        top: 0;
      }

      .subscribe-form-label {
        text-align: right;

        @media only screen and (max-width: 767px) {
          text-align: left;
        }
      }
    }

    .close-popup {
      opacity: 0.4;
      position: absolute;
      top: 0;
      right: 0;
      padding: 20px;
      cursor: pointer;

      @media only screen and (max-width: 640px) {
        top: -10px;
      }

      &:hover {
        opacity: 1;
      }
    }
  }
}

#consent-radios {
  i.clickable {
    cursor: pointer;

    &:hover {
      opacity: 0.7;
    }
  }

  span {
    cursor: pointer;
  }
}
</style>

<style scoped>
.error {
  margin-top: 10px;
  font-weight: bold;
}
</style>
